import { getAppointmentAssessments, getAppointmentIntakeAssessment } from '@uplift/api';
import { useQuery } from '@tanstack/react-query';

export const useAppointmentAssessments = (appointmentId: string) => {
  const { data, isLoading, isRefetching } = useQuery({
    queryKey: [ 'appointments-assessments', appointmentId ],
    queryFn: () => getAppointmentAssessments({ appointment_id: appointmentId }),
    retry: 1,
    refetchOnMount: true,
    keepPreviousData: false,
  });

  return { appointmentAssessments: data?.assessments ?? [], isLoading: isLoading || isRefetching };
};

export const useAppointmentIntakeAssessment = (appointmentId: string, enabled = true) => {
  const { data, isLoading, isRefetching } = useQuery({
    queryKey: [ 'appointment-intake-assessment', appointmentId ],
    queryFn: () => getAppointmentIntakeAssessment({ appointment_id: appointmentId }),
    retry: 1,
    refetchOnMount: true,
    keepPreviousData: false,
    enabled: enabled,
  });

  return { appointmentIntakeAssessment: data?.intakeForm || null, isLoading: isLoading || isRefetching };
};
